<template>
  <div class="tax-info-card" :class="this.variant">
    <div class="row no-gutters">
      <div class="col text-right">
        Татварт суутгах дүн
      </div>
      <div class="col text-center">
        &asymp;{{ amount }}
      </div>
    </div>
    <div class="row no-gutters">
      <div class="col">
        <div class="hint">
          {{ msg }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    variant: {type: String, default: 'warning'},
    title: {type: String, default: 'Санамж'},
    amount: {type: String, default: ''},
    msg: {type: String, default: ''},
  }
}
</script>
<style scoped lang="scss">
.tax-info-card {
  border-radius: 6px;
  border-color: grey;
  font-size: 0.8rem;
  padding: 10px;
  font-weight: 500;
  color: var(--text-primary-color-alpha-9);

  .hint {
    padding: 0;
    margin-top: 5px;
    font-weight: 500;
    //margin: 0;
    color: grey;
    font-size: 0.6rem;
    width: 250px;
  }
  &.warning {
    border: 1px solid #F0B400;
    background-color: #F0B4001A;
  }
  &.success {
    border: 1px solid darkgreen;
  }
  &.error {
    border: 1px solid red;
  }
}
</style>